import { inject, type InjectionKey } from 'vue'

// Provided by a shell that renders the route title in its own header.
export const SHELL_OWNS_TITLE: InjectionKey<boolean> = Symbol('shellOwnsTitle')

export function useShellOwnsTitle(): boolean {
  return inject(SHELL_OWNS_TITLE, false)
}
